import React, { useState, useEffect, useRef, useCallback } from "react";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useAtom } from "jotai";
import "../css/appointment.css";

import { useCurrentRole } from "../../../_helper/constant/Permission";
import {
  getQueryTime,
  getTimeInSeconds,
  getTotalAppointmentsInMonth,
} from "../../_helper/utils.js/utils";
import { months } from "../constant/AppointmentConstants";
import { calculateWeekRange } from "../../_helper/utils.js/utils";
import CuScreenLoader from "../../../common_component/component/CuScreenLoader";
import { dateAtom, isOnlineAtom, loadingAtom } from "../atom/AppointmentAtoms";
import "../css/OldAppointment.css";
import { format } from "date-fns";
import { dateConvertToPayloadBookingFormat } from "../../../components/admin/setup/helper/Helper";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useSearchParams } from "react-router-dom";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import MyCalendar from "./MyCalendar";
import { setCookie } from "../../../_helper/utils/utils";
import { WEBSOCKET_URL } from "../../../_helper/constant/constant";

const convertDateRange = (inputDateRange) => {
  if (inputDateRange === null) {
    return;
  }
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  let output = {};

  if (inputDateRange.includes("–")) {
    const [startDate, endDate] = inputDateRange
      .split("–")
      .map((date) => date.trim());

    const startDateObj = new Date(startDate);
    let endDateObj;

    if (/^\d+$/.test(endDate)) {
      endDateObj = new Date(
        `${currentYear}-${startDateObj.getMonth() + 1}-${endDate}`
      );
    } else {
      endDateObj = new Date(endDate);
    }

    if (startDateObj.getMonth() === endDateObj.getMonth()) {
      const startMonth = startDateObj.getMonth() + 1;
      const startDay = startDateObj.getDate();
      const endDay = endDateObj.getDate();
      output["_between"] = [
        `${currentYear}-${startMonth}-${startDay}`,
        `${currentYear}-${startMonth}-${endDay}`,
      ];
    } else {
      const startDateYear = startDateObj.getFullYear();
      const startDateMonth = String(startDateObj.getMonth() + 1).padStart(
        2,
        "0"
      );
      const startDateDay = String(startDateObj.getDate()).padStart(2, "0");
      const endDateYear = endDateObj.getFullYear();
      const endDateMonth = String(endDateObj.getMonth() + 1).padStart(2, "0");
      const endDateDay = String(endDateObj.getDate()).padStart(2, "0");

      if (startDateYear !== endDateYear) {
        output["_between"] = [
          `${startDateYear}-${startDateMonth}-${startDateDay}`,
          `${endDateYear}-${endDateMonth}-${endDateDay}`,
        ];
      } else {
        output["_between"] = [
          `${currentYear}-${startDateMonth}-${startDateDay}`,
          `${currentYear}-${endDateMonth}-${endDateDay}`,
        ];
      }
    }
  } else {
    const inputMonthYear = inputDateRange.trim().split(" ");
    const inputMonth = inputMonthYear[0];
    const inputYear = parseInt(inputMonthYear[1], 10) || currentYear;

    const daysInMonth = new Date(
      inputYear,
      new Date(Date.parse(inputMonth + " 1, " + inputYear)).getMonth() + 1,
      0
    ).getDate();

    const inputMonthFormatted = String(
      new Date(Date.parse(inputMonth + " 1, " + inputYear)).getMonth() + 1
    ).padStart(2, "0");

    output["_between"] = [
      `${inputYear}-${inputMonthFormatted}-01`,
      `${inputYear}-${inputMonthFormatted}-${daysInMonth}`,
    ];

    if (inputMonth === "February") {
      output["_between"][1] = `${inputYear}-${inputMonthFormatted}-29`;
    }
  }

  return output;
};

const Appointment = () => {
  const [events, setEvents] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isJumpDate, setIsJumpDate] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const allClinic = searchParams.get("all_clinic");
  const dayCycle = searchParams.get("view");

  const { role_id, isLoading } = useCurrentRole();
  const [date, setDate] = useAtom(dateAtom);

  const [isOpen, setIsOpen] = useState({
    flag: false,
    startTime: "",
    type: "walkin",
    manualTime: false,
  });

  const [, setIsOnline] = useAtom(isOnlineAtom);
  const [, setLoading] = useAtom(loadingAtom);

  const setAllClinic = (checked) => {
    const newParams = new URLSearchParams(searchParams);
    // navigate(`/new/appointment?all_clinic=${checked}`);
    newParams.set("all_clinic", checked);
    setSearchParams(newParams);
  };

  const openModal = () =>
    setIsOpen({ flag: true, startTime: "", type: "walkin" });
  //   const [onclktime, setOnclktime] = useState();
  //   const [start_date, setStart_date] = useState();
  const [userViewID, setuserViewID] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const initialSession = searchParams.get("session") || "All";

  const [selectedSession, setSelectedSession] = useState({
    startTime: moment()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate(),
    endTime: moment()
      .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
      .toDate(),
    name: initialSession,
  });

  const [isCustomSession, setIsCustomSession] = useState(
    initialSession === "Custom"
  );
  const [customSessionData, setCustomSessionData] = useState({
    startTime: moment(selectedSession?.startTime)?.format("HH:mm"),
    endTime: moment(selectedSession?.endTime)?.format("HH:mm"),
  });

  const [selectedStartEndTime, setselectedStartEndTime] = useState({
    startTime: moment()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]"),
    endTime: moment()
      .set({ hour: 23, minute: 59, second: 0, millisecond: 0 })
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss[Z]"),
  });

  const [totalAppointments, setAppointment] = useState();
  const [AllData, setAllData] = useState({});

  useEffect(() => {
    setCookie("dayCycle", dayCycle, 7);
  }, [dayCycle]);

  useEffect(() => {
    if (role_id) {
      let startTime;
      let endTime;
      if (dayCycle === "day") {
        const timing = getQueryTime(selectedSession, date);
        startTime = timing?.startTime;
        endTime = timing?.endTime;

        setselectedStartEndTime({
          startTime: dateConvertToPayloadBookingFormat(startTime),
          endTime: dateConvertToPayloadBookingFormat(endTime),
        });
      }
      if (dayCycle === "month") {
        const selectedMonth = months[date?.getMonth()];
        const selectedYear = date?.getFullYear();
        const [start_time, end_time] = convertDateRange(
          `${selectedMonth} ${selectedYear}`
        )?._between;
        const endOfDay = new Date(end_time);
        endOfDay.setHours(23, 59, 59, 999);

        const endTimeAdjusted = endOfDay.toISOString();

        setselectedStartEndTime({
          startTime: dateConvertToPayloadBookingFormat(start_time),
          endTime: dateConvertToPayloadBookingFormat(endTimeAdjusted),
        });
      }

      if (dayCycle === "week") {
        const [startOfWeek, endOfWeek] = calculateWeekRange(date);

        const formattedStartOfWeek = format(startOfWeek, "yyyy-MM-dd");
        const formattedEndOfWeek = format(endOfWeek, "yyyy-MM-dd");
        const [start_time, end_time] = [
          formattedStartOfWeek,
          formattedEndOfWeek,
        ];
        startTime = start_time;
        endTime = end_time;

        setselectedStartEndTime({
          startTime: dateConvertToPayloadBookingFormat(startTime),
          endTime: dateConvertToPayloadBookingFormat(endTime),
        });
      }
    }
  }, [dayCycle, date, selectedSession, role_id]);

  let getAllSlots = `?action=getAllSlots&clinic_id=${clinic?.id}&backend=True&date=${selectedStartEndTime?.startTime}to${selectedStartEndTime?.endTime}&doctor_id=${role_id}&session=True`;

  if (allClinic === "true") {
    getAllSlots = `?action=getAllSlots&clinic_id=${clinic?.id}&backend=True&date=${selectedStartEndTime?.startTime}to${selectedStartEndTime?.endTime}&doctor_id=${role_id}&all_clinic=True&session=True`;
  }

  const {
    data,
    refetch,
    isLoading: isSlotLoading,
  } = useItemsFilter(
    ApiEndPoint?.QM_SC_SLOTS,
    getAllSlots,
    role_id ? true : false
  );

  const wsUrl = role_id ? `${WEBSOCKET_URL}ws/app/${role_id}/` : null;
  const wsRef = useRef(null);

  const connectWebSocket = useCallback(() => {
    if (!wsUrl) {
      return;
    }

    // Set loading state to true when starting connection
    setLoading(true);

    // Close any existing WebSocket connection
    if (wsRef.current) {
      wsRef.current.close();
    }

    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      //("WebSocket connection opened.");
      setIsOnline(true);
      setLoading(false); // Set loading state to false when connection is opened
    };

    ws.onmessage = (event) => {
      const receivedData = JSON.parse(event.data);
      //("Message received from server:", receivedData?.message);
      // setData(receivedData?.message?.data);
      refetch();
    };

    ws.onerror = (error) => {
      //("WebSocket error:", error);
      setIsOnline(false);
      setLoading(false); // Set loading state to false on error
    };

    ws.onclose = () => {
      //("WebSocket connection closed.");
      setIsOnline(false);
      setLoading(false); // Set loading state to false when connection is closed
    };

    // Call refetch whenever WebSocket is (re)connected
    refetch();
  }, [wsUrl, refetch]);

  useEffect(() => {
    connectWebSocket();

    // Cleanup function to close the WebSocket connection when the component unmounts
    return () => {
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [wsUrl, clinic, selectedStartEndTime, role_id, connectWebSocket]);

  useEffect(() => {
    if (data) {
      const modifiedEvents =
        data?.booked_slots?.map((slot) => {
          if (slot?.status !== "rejected") {
            return {
              id: slot?.id,
              title: slot?.status,
              allDay: false,
              is_walk_in: slot?.is_walk_in,
              meeting_id: slot?.meeting_id,
              patient: slot?.patient_type,
              bill_id: slot?.bill_id,
              visit_gap: slot?.visit_gap,
              visit_count: slot?.follow_up_visit,
              billing_status: slot?.billing_status,
              custom_field_1: slot?.custom_field_1,
              ipd: {
                id: slot?.ipds?.id,
                ipd_number: slot?.ipds?.ipd_number,
              },
              opd:
                slot?.consultation_data?.length > 0
                  ? slot?.consultation_data[0]
                  : null,
              clinic_id: slot?.clinic_id?.id,
              text: `${
                new Date(slot?.start_time).getHours() >= 12
                  ? `${new Date(slot?.start_time).getHours()}:${
                      new Date(slot?.start_time).getMinutes() < 10
                        ? `0${new Date(slot?.start_time).getMinutes()}`
                        : `${new Date(slot?.start_time).getMinutes()}`
                    } P.M`
                  : `${new Date(slot?.start_time).getHours()}:${
                      new Date(slot?.start_time).getMinutes() < 10
                        ? `0${new Date(slot?.start_time).getMinutes()}`
                        : `${new Date(slot?.start_time).getMinutes()}`
                    } A.M`
              } 
        `,
              start: new Date(slot?.start_time),
              end: new Date(slot?.end_time),
              user_details: slot?.user_details,
              user_created: slot?.user_details?.user_created,
              preconsultation: slot?.preconsultation,
            };
          }
        }) || [];

      const modifiedOpenSlots =
        data?.open_slots?.map((oslot, idx) => {
          const start_time = getTimeInSeconds(oslot?.start_time);
          const end_time = getTimeInSeconds(oslot?.end_time);
          return {
            do_booking_data: {
              start_time,
              end_time,
              duration: 900,
              status: oslot?.status,
              start_dt: moment(oslot?.start_time).toDate(),
              end_dt: moment(oslot?.end_time).toDate(),
            },
            id: idx,
            title: oslot?.status,
            booked_id: 0,
            clinic_id: oslot?.clinic_id,
            allDay: false,
            start: moment(oslot?.start_time).toDate(),
            end: moment(oslot?.end_time).toDate(),
            text: `${moment(oslot?.end_time).format("hh:mm A")}        Open`,
            user_details: {},
            user_created: {},
          };
        }) || [];

      const modifiedBlockSlots =
        data?.blocked_slots?.map((oslot, idx) => {
          const start_time = getTimeInSeconds(oslot?.start_time);
          const end_time = getTimeInSeconds(oslot?.end_time);
          return {
            do_booking_data: {
              start_time,
              end_time,
              duration: 900,
              status: oslot?.status,
              start_dt: moment(oslot?.start_time).toDate(),
              end_dt: moment(oslot?.end_time).toDate(),
            },
            id: oslot?.id,
            title: oslot?.status,
            booked_id: 0,
            allDay: false,
            clinic_id: oslot?.clinic_id,
            start: moment(oslot?.start_time).toDate(),
            end: moment(oslot?.end_time).toDate(),
            text: `${moment(oslot?.end_time).format("hh:mm A")}        Open`,
            user_details: {},
            user_created: {},
          };
        }) || [];

      const { total_appointment, completed, no_show, remaining } = data;

      const appointmentData = {
        total_appointment,
        completed,
        no_show,
        remaining,
      };

      setEvents([
        ...modifiedEvents,
        ...modifiedOpenSlots,
        ...modifiedBlockSlots,
        appointmentData,
      ]);
    }
  }, [data]);

  useEffect(() => {
    const data = events;
    const result = getTotalAppointmentsInMonth(data);
    setAppointment(result[0].month);
  }, [events]);

  return (
    <>
      <div className="sm:h-auto sm:px-5 sm:py-2 sm:mx-0 sm:my-0 md:mx-30">
        <MyCalendar
          events={events}
          dayCycle={dayCycle}
          userViewID={userViewID}
          selectedDoctor={role_id}
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
          totalAppointments={AllData}
          isSearchOpen={isSearchOpen}
          setIsSearchOpen={setIsSearchOpen}
          bookAppointment={setIsOpen}
          isCustomSession={isCustomSession}
          setIsCustomSession={setIsCustomSession}
          customSessionData={customSessionData}
          setCustomSessionData={setCustomSessionData}
          isJumpDate={isJumpDate}
          setIsJumpDate={setIsJumpDate}
          clinic_id={clinic?.id}
          role_id={role_id}
          date={date}
          setDate={setDate}
          allClinic={allClinic}
          setAllClinic={setAllClinic}
          connectWebSocket={connectWebSocket}
        />
      </div>
      {(isSlotLoading || isLoading) && <CuScreenLoader />}
    </>
  );
};

export default Appointment;
